import {
    useRef,
    useState
} from 'react';

import {SimpleGrid} from '@mantine/core';

import {useMeterAssignments} from '../hooks/useMeterAssignments.ts';
import {useMeterAssignmentsSelection} from '../hooks/useMeterAssignmentsSelection.ts';
import {useTableColumns} from '../hooks/useTableColumns.tsx';
import {FormDrawer} from '../drawers/FormDrawer.tsx';
import {update} from '../services/MeterAssignmentsService.ts';
import {buildUpdateMeterAssignmentInput} from '../services/buildMeterAssignmentInput.ts';

import {
    MantineDataTable,
    TableSearchForm,
} from '@flexinet/ui-components';
import {DataTableTokenPagination} from "../../../components/DataTableTokenPagination.tsx";
import {MeterAssignment} from '../types';
import {useQueryClient} from '@tanstack/react-query';

export const RecordsTable = () => {
    const {selectedRecords, setSelectedRecords} = useMeterAssignmentsSelection();
    const {columns} = useTableColumns();
    const [drawerOpened, setDrawerOpened] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState<MeterAssignment | null>(null);
    const queryClient = useQueryClient();

    const {
        items,
        totalCount,
        loading,
        nextToken,
        fetchRecords,
        handleFilterByKeyword
    } = useMeterAssignments();

    const scrollViewportRef = useRef<HTMLDivElement>(null);

    const handleDrawerSubmit = async (values: MeterAssignment) => {
        if (selectedRecord?.id) {
            await update(selectedRecord.id, buildUpdateMeterAssignmentInput(values) as MeterAssignment);
            queryClient.invalidateQueries({queryKey: ['meterAssignments']});
        }
    };

    return (
        <SimpleGrid verticalSpacing='xl' m='sm'>
            <TableSearchForm handleFilterByKeyword={handleFilterByKeyword}/>

            <MantineDataTable
                columns={columns}
                records={items}
                selectedRecords={selectedRecords}
                onSelectedRecordsChange={setSelectedRecords}
                fetching={loading}
                onScrollToBottom={() => fetchRecords()}
                scrollViewportRef={scrollViewportRef}
                withTableBorder={true}
                onRowClick={({record}) => {
                    setSelectedRecord(record);
                    setDrawerOpened(true);
                }}
            />

            <DataTableTokenPagination totalCount={totalCount.toString()} nextToken={nextToken}
                                      handleLoadMore={fetchRecords}/>

            {drawerOpened && selectedRecord && (
                <FormDrawer
                    record={selectedRecord}
                    handleSubmit={handleDrawerSubmit}
                    opened={drawerOpened}
                    onClose={() => {
                        setDrawerOpened(false);
                        setSelectedRecord(null);
                    }}
                />
            )}
        </SimpleGrid>
    );
};
